export default {
    title: {
        register: 'Register',
        termsAndCond: "Terms & Conditions",
        privacy: "Data Privacy",
        marketing: "MARKETING POLICY ON USE OF PERSONAL DATA"
    },
    body: {
        fillEng: "Please fill in the field in English",
        iAgree: "I agree with <span class='label-terms underline'>Terms & Conditions</span> and <span class='label-privacy  underline'>Data Privacy</span>",
        term: "I agree with <span class='label-terms underline'>Terms & Conditions</span>",
        privacy: "I agree with <span class='label-privacy underline'>Data Privacy</span>",
        marketing: "I consent <span class='label-marketing underline'>Marketing Policy</span>",
        mkt_title: "Allow channel to marketing message, <br /> please select at least 1 channel.",
        mkt_all: "ทั้งหมด",
        mkt_email: "Email",
        mkt_sms: "SMS / Phone",
        mkt_noti: "Notification",
    },
    buttons: {
        register: 'Register',
        accept: 'Accepted',
        unaccept: 'Unaccepted'
    },
    bottomSheet: {
        txtSuccess: "Registered  <br /> JCB Thailand successful",
        txtConnecting: "Connecting ..."
    },
    form: {
        firstName: {
            name: 'Name *',
            placeholder: '',
            required: 'Please enter your firstname.',
            onlyEng: 'Please fill in the field in English',
            too_short: '',
            invalid: '',
        },
        lastName: {
            name: 'Lastname *',
            placeholder: '',
            required: 'Please enter your lastname.',
            onlyEng: 'Please fill in the field in English',
            too_short: '',
            invalid: '',
        },
        dateOfBirth: {
            name: 'Date of Birth *',
            placeholder: '',
            required: 'Please enter your date of birth',
            too_short: '',
            invalid: '',
            date: 'DD',
            month: 'MM',
            year: 'YYYY',
        },
        gender: {
            name: "Gender *",
            required: "Please choose gender",
            labels: {
                male: "Male",
                female: "Female",
                none: "Prefer not to say"
            }
        },
        email: {
            name: 'E-mail *',
            placeholder: '',
            required: 'Please enter your email',
            too_short: '',
            invalid: 'The email address is incorrect.',
        },
        mobileNo: {
            name: 'Phone Number *',
            placeholder: '',
            required: 'Please enter your mobile number.',
            too_short: '',
            invalid: '',
        },
        countryName: {
            name: 'Country',
            placeholder: '',
            required: 'Please enter your country.',
            too_short: '',
            invalid: '',
        },
        provinceName: {
            name: 'Province',
            placeholder: '',
            required: 'Please enter your province.',
            too_short: '',
            invalid: '',
        }
    },
    errUnder18: "Sorry, you can't register. due to under 18 years of age",
    errPhoneNumberDuplicated: "Sorry! Your phone number is already in the system. please check again.",
    errLineDuplicated: "Sorry! This LINE account is already registered with a different phone number. please check again.",
    errEmailDuplicated: "Sorry! Your email address is already in the system. Please check again.",
}
